<template>
  <span>
    <template v-if="type === 'dots'">
      <span class="loading-dots">
        <span class="dot one">.</span><span class="dot two">.</span><span class="dot three">.</span>
      </span>
    </template>
  </span>
</template>

<script>
export default {
  props: {
    type: {
      type: String,
      default: 'dots'
    }
  }
};
</script>

<style lang="scss" scoped>
.loading-dots {
  text-align: center;
  z-index: 5;
  .dot {
    display: inline;
    margin-left: 1px;
    margin-right: 1px;
    font-size: 22px;
    opacity: 0;
    animation: showHideDot 0.8s ease-in-out infinite;

    &.one { animation-delay: 0.1s; }
    &.two { animation-delay: 0.2s; }
    &.three { animation-delay: 0.3s; }
  }
}
@keyframes showHideDot {
  0% { opacity: 0; }
  50% { opacity: 1; }
  60% { opacity: 1; }
  100% { opacity: 0; }
}
</style>


// WEBPACK FOOTER //
// src/components/Loading.vue